import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const lensFilterOptionsContainer = css`
    padding: ${Spacing.SM}px ${Spacing.SM}px;
`;
